"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgYoutubeCircle = function SvgYoutubeCircle(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M0 512C0 229.2 229.2 0 512 0s512 229.2 512 512-229.2 512-512 512S0 794.8 0 512zm773.7-126.4c-6.3-24.1-24.8-43.1-48.3-49.6-42.6-11.7-213.4-11.7-213.4-11.7s-170.8 0-213.4 11.7c-23.5 6.4-42 25.4-48.3 49.6-11.4 43.7-11.4 135-11.4 135s0 91.2 11.4 135c6.3 24.1 24.8 43.1 48.3 49.6 42.6 11.6 213.4 11.6 213.4 11.6s170.8 0 213.4-11.7c23.5-6.5 42-25.5 48.3-49.6 11.4-43.7 11.4-135 11.4-135s0-91.2-11.4-134.9zM469.3 597.3V426.7L605.9 512l-136.6 85.3z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgYoutubeCircle, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;